export default "__VITE_ASSET__uRzof2ps__"